import { Persistor, Store } from '../../stores/store';
import { Route, Router, Switch } from "react-router-dom";

import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import React from "react";
import { createBrowserHistory } from "history";
import indexRoutes from "../../routes/index.jsx";
import AppErrorBoundary from './AppErrorBoundary';

const hist = createBrowserHistory();
const App = () => (
    <AppErrorBoundary>
        < Provider store={Store} >
            <PersistGate loading={null} persistor={Persistor}>
                <Router history={hist} >
                    <Switch>
                        {indexRoutes.map((prop, key) => {
                            return <Route path={prop.path} component={prop.component} key={key} />;
                        })}
                    </Switch>
                </Router>
            </PersistGate>
        </Provider>
    </AppErrorBoundary>
)

export default App;